import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=70171480&scoped=true&"
import script from "./Header.ts?vue&type=script&lang=ts&"
export * from "./Header.ts?vue&type=script&lang=ts&"
import style0 from "./Header.vue?vue&type=style&index=0&id=70171480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70171480",
  null
  
)

export default component.exports